<template>
  <div id="app">
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  border-radius: 2px;
}
.btn {
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.btn:hover {
  background: hsla(180, 64%, 42%, 0.05);
  color: hsla(180, 64%, 42%, 0.5);
}
.btn.active {
  color: hsla(180, 64%, 42%, 1);
}
.el-button--senkoo {
  color: hsla(0, 0%, 100%, 1) !important;
  background-color: hsla(180, 64%, 42%, 1) !important;
  border-color: hsla(180, 64%, 42%, 1) !important;
}
/* .el-button--senkoo.is-disabled {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important; 
}*/
.el-button--senkoo.is-disabled,
.el-button--senkoo.is-disabled:active,
.el-button--senkoo.is-disabled:focus,
.el-button--senkoo.is-disabled:hover {
  color: hsla(0, 0%, 100%, 1) !important;
  background-color: hsla(180, 64%, 42%, 0.5) !important;
  border-color: hsla(180, 64%, 42%, 0.5) !important;
}
@media screen and (max-width: 750px) {
  .permision-dialog {
    max-width: 100%;
  }
  .btn {
    font-weight: bold;
    font-size: 22px;
  }
  .el-message-box {
    /* color: red; */
    max-width: 100%;
  }
}
</style>
